<template>
   <section class="mt-12 px-2 lg:mt-20">
      <p class="text-center text-2xl lg:text-3xl font-bold" style="color: #062648">Our board of directors</p>
      <div class="mt-12 pl-3">
        <ul class="flex figlist gap-10 lg:gap-0">
          <li v-for="director in directors" :key="director.id">
            <figure>
              <div>
                <img :src="`${baseURL}/staff/${director.picture}`" onerror="this.onerror=null;this.src='https://upload.wikimedia.org/wikipedia/commons/1/14/No_Image_Available.jpg';" alt="" class="figimg">
              </div>
              <figcaption class="text-center">
                <p class="font-bold text-gray-500 text-sm">{{director.fullname}}</p>
                <p class="text-blue-500 font-light text-sm">{{director.post}}</p>
              </figcaption>
            </figure>
            <div class="details hidden rounded shadow-lg absolute right-0 bg-white top-0 py-6 px-6">
              <p class="font-bold text-sm">{{director.fullname}}</p>
              <p class="mt-2 text-sm" style="color:#062648">{{director.post}}</p>
              <p class="mt-4 text-gray-500 text-xs leading-6">{{director.about}}</p>
            </div>
          </li>
          
        </ul>
      </div>
    </section>
</template>

<script>
// import axios from 'axios'
import baseURL from '@/main'
export default {
  props: ['directors'],
  data(){
    return {
      baseURL: baseURL
    }
  },
  mounted() { 
    // this.$store.commit('startLoading')
    // axios.get(`${baseURL}/api/directors`)
    // .then(res=>{
    //   this.directors = res.data.result
    //   console.log(this.directors)
    //   this.$store.commit('stopLoading')
    // })
    // .catch(err=>{
    //   this.$store.commit('stopLoading')
    //   console.log(err)
    // })
    
  }
}
</script>

<style scoped>
.figimg{
  width: 150px;
  height: 150px;
  margin-left: auto;
  margin-right: auto;
  border-radius: 50%;
}
figure div{
  border: 1px solid #062648;
  background-color: #fff;
  border-radius: 50%;
  padding: 7px;
  text-align: center;
}
figcaption{
  margin-top: 10px;
}
.figlist, .figlist2{
  flex-wrap: wrap;
  
}
.figlist li, .figlist2 li{
  max-width: 43%;
  position: relative;
}
@media only screen and (min-width: 1024px){
.figlist li:hover > div.details{
  display: block;
}
div.details{
  width: 350px;
  max-height: 500px;
  overflow-x: auto;
  overflow-y: auto;
  top: -50px;
  right: -350px;
  z-index: 100
}
.details::-webkit-scrollbar
{
  width: 0px;
	background-color: #F5F5F5;
}
.figlist, .figlist2{
    padding-left: 80px;
    padding-right: 40px;
  }
 .figlist{
    margin-left: 30px
  }
  .figlist li{
    width: 13%;
    min-width: 150px;
    margin: 20px 30px 
  }
}
</style>